export abstract class IAnalyticsService {
  public abstract setBrowserLanguage(browserLanguage);
  public abstract setEstablishmentName(establishmentName);
  public abstract setEstablishmentId(establishmentId);
  public abstract setUserCountry(country);
  public abstract setWebListingSection(section);
  public abstract setBusinessId(salesForceId);
  public abstract setEstablishmentZipCode(zipCode);
  public abstract setEstablishmentCountry(country);
  public abstract setEstablishmentCategory(category);
  public abstract setSelectedLanguage(language);
  public abstract setDomain(domain);
  public abstract setProductVersion(product);
  public abstract setPageName();
  public abstract setPageType(pageType);
}
